import React, { Component } from "react";
import { connect } from "react-redux";
import { Col, Row, Table, FormGroup, FormControl } from "react-bootstrap";
import FileStatusInfo from "components/FileStatusInfo";
import { TooltipIcon, DownloadButton, IconLabel, MailtoLink } from "ctia-ui";
import { getDocStatus } from "helpers/DocumentStatus";
import { findTestById, hasReportDocuments } from "helpers/RequestTestsHelper";
import { getRequestMailtoInfo } from "helpers/Emails";
import { testReportDownload, updateTestReportStatus } from "actions/tests";
import { startPreloader, finishPreloader } from "actions/preloader";
import { updateRequest } from "actions/request";

class LabTestResult extends Component {
  onSelect = (testId, slot, event) => {
    const value = event.target.value;
    const {
      startPreloader,
      finishPreloader,
      updateTestReportStatus,
      updateRequest,
      request
    } = this.props;

    startPreloader();
    updateTestReportStatus(testId, slot, value).then(() => {
      updateRequest({ id: request.id }).then(finishPreloader);
    });
  };

  render() {
    const { user, testModule, request, testReportDownload } = this.props;

    if (!testModule) return null;
    if (!testModule.reports || !testModule.reports.length) return null;
    if (!hasReportDocuments(testModule.reports)) return null;

    const title = findTestById(testModule.interfaceid).title;

    return (
      <div>
        <h3>{title} Test Results</h3>
        <Row>
          <Col xs={1} style={{ width: 165 }}>
            <FileStatusInfo />
          </Col>
          <Col xs={10}>
            <Table responsive striped>
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Document Title</th>
                  <th />
                  <th style={{ width: 150 }} />
                </tr>
              </thead>
              <tbody>
                {testModule.reports.map((doc, i) => {
                  const status = doc.document.documentstatusid;
                  const statusInfo = getDocStatus(status);
                  const renderReporterLink = () => {
                    if (!doc.user || !doc.user.email) return null;

                    const reqValues = getRequestMailtoInfo(request);
                    const mailToValues = {
                      email: doc.user.email,
                      ...reqValues
                    };

                    return (
                      <div>
                        <IconLabel
                          awesomeIcon="user"
                          label={
                            <MailtoLink value={mailToValues} asInline={true} />
                          }
                        />
                      </div>
                    );
                  };

                  return (
                    <tr key={i}>
                      <td>
                        <TooltipIcon
                          glyph={statusInfo.icon}
                          tipText={statusInfo.title}
                        />
                      </td>
                      <td>
                        <IconLabel
                          label={<b>{doc.document.title}</b>}
                          awesomeIcon="file-invoice"
                        />
                        {renderReporterLink()}
                      </td>
                      {/* <!--- Next block shows only for staff user ---> */}
                      <td>
                        {user.isStaff && (
                          <FormGroup controlId="tests">
                            <FormControl
                              componentClass="select"
                              value={status}
                              onChange={this.onSelect.bind(
                                this,
                                doc.requesttestid,
                                doc.slot
                              )}
                              disabled={!user.canEditRequest}
                            >
                              <option value={1}>--- Not selected ---</option>
                              <option value={2}>Approved</option>
                              <option value={3}>Rejected</option>
                            </FormControl>
                          </FormGroup>
                        )}
                      </td>
                      <td style={{ width: 150 }}>
                        <DownloadButton
                          size="small"
                          action={testReportDownload.bind(this, doc, request)}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
        </Row>
        <hr />
      </div>
    );
  }
}

function mapStateToProps({ user, request }) {
  return { user, request };
}

export default connect(mapStateToProps, {
  testReportDownload,
  updateTestReportStatus,
  startPreloader,
  finishPreloader,
  updateRequest
})(LabTestResult);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/LabTestResult.js